/**
 * @desc 订单取消
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export type Response = defs.omsFlow.Response;
export function request(soOrderNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/systemOrder/cancel/${soOrderNo}`, {
      method: "POST",

      ...options,
    }),
  );
}
